import {map} from "rxjs/operators";
import Api from "../../Api";
import Constants from "../../Constants";
import {ResultListDto} from "../ResultListDto";
import {ElementDto} from "./ElementDto";
import {ElementFilterDto} from "./ElementFilterDto";

export interface StereotypeFromPropertyUpdateDto {
    identifiers: string[],
    stereotypePropertyName: string,
}

export interface StereotypeFromPropertyUpdateReportDto {
    updatedCount: number,
    skippedCount: number,
}

export class ElementApiClient {
    public static readonly ELEMENTS_BASE_URL: string = Constants.REST_API_URL + "/repository/elements";

    findByFilter(filter: ElementFilterDto): Promise<ResultListDto<ElementDto>> {
        const request = {
            url: `${ElementApiClient.ELEMENTS_BASE_URL}:search`,
            method: "POST",
            body: filter,
        };
        return Api.createAjax(request)
                .pipe(
                        map(response => response.response as ResultListDto<ElementDto>)
                )
                .toPromise();
    }

    updateStereotypeFromProperty(stereotypeFromPropertyUpdate: StereotypeFromPropertyUpdateDto): Promise<StereotypeFromPropertyUpdateReportDto> {
        const request = {
            url: `${ElementApiClient.ELEMENTS_BASE_URL}/bulk/stereotype:update-from-property`,
            method: "POST",
            body: stereotypeFromPropertyUpdate,
        };
        return Api.createAjax(request)
                .pipe(
                        map(response => response.response)
                )
                .toPromise();
    }
}
